/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import PropTypes from 'prop-types';

export const LotteryDateProps = PropTypes.shape({
    seconds: PropTypes.number,
});

export const LotteryProps = PropTypes.shape({
    declined_award_rule: PropTypes.string,
    end_date: PropTypes.string,
    is_active: PropTypes.bool,
    lottery: PropTypes.shape({
        announced_at: LotteryDateProps,
        close_at: LotteryDateProps,
        created_at: LotteryDateProps,
        deadline_at: LotteryDateProps,
        id: PropTypes.string,
        inventory_id: PropTypes.string,
        inventory_info: PropTypes.shape({
            dates: PropTypes.shape({
                start: LotteryDateProps,
                end: LotteryDateProps,
            }),
            details_url: PropTypes.string,
            enter_url: PropTypes.string,
            facility_id: PropTypes.string,
            facility_name: PropTypes.string,
            facility_type: PropTypes.string,
            facility_url: PropTypes.string,
        }),
        inventory_type: PropTypes.string,
        name: PropTypes.string,
        open_at: LotteryDateProps,
        ran_at: LotteryDateProps,
        scheduled_at: LotteryDateProps,
        updated_at: LotteryDateProps,
    }),
    lottery_id: PropTypes.string,
    payment_type: PropTypes.string,
    permit_id: PropTypes.string,
    release_unawarded_quota_date: PropTypes.string,
    start_date: PropTypes.string,
    status: PropTypes.number,
    type: PropTypes.string,
});

export const LotteryPreferenceProps = PropTypes.shape({
    preferred_date: PropTypes.string,
});

export const LotteryPreferencePickerProps = PropTypes.shape({
    preferred_date: PropTypes.any,
});
